export default {
  dateDetailed: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  }
}
